import { render } from "./FWLN.vue?vue&type=template&id=5801c4de"
import script from "./FWLN.vue?vue&type=script&lang=js"
export * from "./FWLN.vue?vue&type=script&lang=js"

import "./FWLN.vue?vue&type=style&index=0&id=5801c4de&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__